module.exports = __webpack_public_path__ + "img/ClickForSound_26.2e21c589.png";